import { AuthService } from "@auth0/auth0-angular";
import { Router } from "@angular/router";
import { catchError, EMPTY, map, Observable, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment.prod";
import { Auth0UserProfileModel } from "src/util/auth0/models/auth0-user-profile.model";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";

export class ResolverHelper {
    static hasPermission(authService: AuthService, permission: EVServiceType | EVServiceType[], needAll: boolean = false): Observable<boolean> {
        if (permission == null) {
            return authService.isAuthenticated$;
        } else {
            const hasPermission$ = authService.user$.pipe(
                map((user) => {
                    if (user == null) {
                        return false;
                    }

                    const loggedInUser: Auth0UserProfileModel = user as Auth0UserProfileModel;
                    const evPermissions = loggedInUser["https://eiendomsverdi.no/evPermissions"];

                    if (!Array.isArray(permission)) {
                        return evPermissions.includes(permission.toString());
                    }

                    if (needAll) {
                        return permission.every((p) => evPermissions.includes(p.toString()));
                    } else {
                        return permission.some((p) => evPermissions.includes(p.toString()));
                    }
                }),
            );
            return hasPermission$;
        }
    }
    static redirectToFrontPage(authService: AuthService, router: Router) {
        return this.hasPermission(authService, EVServiceType.Internal_Debug).pipe(
            take(1),
            switchMap((hasDebugRole) => {
                if (hasDebugRole) {
                    this.redirectToFrontPage50(router);
                } else {
                    this.redirectToFrontPage40();
                }
                return EMPTY;
            }),
            catchError((error) => {
                console.error("Error checking permissions in resolver:", error);
                this.redirectToFrontPage40();
                return EMPTY;
            }),
        );
    }
    private static redirectToFrontPage40() {
        console.log("Redirecting to front page using window.open");
        var url = environment.evwebUrl + "/frontpage";
        window.open(url, "_self");
    }
    private static redirectToFrontPage50(router: Router) {
        console.log("Redirecting to front page using router.navigate");
        router.navigate(["/frontpage"]);
    }
}
